module.exports = __webpack_public_path__ + "static/media/dying.4849f499.mp3";